(function(window,$) {

	var initialHash = window.location.hash.match(/^#?(.*)$/)[1],
		navMap = {
			'.app_my-jbl-headphones-app': '/my-jbl-headphones-app/',
			'.app_features': '/features/',
			'.app_where-to-download': '/where-to-download/',
			'.app_how-the-app-works': '/how-the-app-works/',
			'.app_faq': '/faq/'
		},
		sections = [];

	$(window).on('load', function() {

		normalizeNav();
		updateNav();

		$.each(navMap, function(selector, hash) {
			if ( $(selector).length ) {
				var newSection = new Carousel($(selector), hash);
				sections.push(newSection);
			}
		});

		sections.sort(function(a, b) {
			if ( a.top > b.top ) {
				return 1;
			} else if ( a.top< b.top) {
				return -1;
			}
			return 0;
		});

		if (initialHash) scrollToHash(initialHash);

	});

	$(window).on('resize orientationchange', function() {
		normalizeNav();
		updateNav();
	});

	$(window).on('scroll', function() {
		updateNav();
	});

	function Carousel(element, hash) {

		var self = this;

		self.hash = hash;
		self.height = element.outerHeight(true);
		self.top = element.offset().top;
		self.bottom = self.top + self.height;

		$(window).on('load resize orientationchange', function() {
			resampleDimensions();
		});

		$('.app_nav a[href="#'+hash+'"]').click(function(event) {
			event.preventDefault();
			var y = $(window).scrollTop(),
				jblHeaderHeight = $('#header').outerHeight(true) + $('.app_nav').outerHeight(true),
				destination = Math.ceil(self.top - jblHeaderHeight),
				pixelsPerMillisecond = 2,
				duration = Math.abs(y - destination) / pixelsPerMillisecond;
			$('.app_main').addClass('app_nav-scroll-animating');
			$('html, body').animate({scrollTop: destination + 'px'}, duration, function() {
				$('.app_main').removeClass('app_nav-scroll-animating');
			});
		});

		function resampleDimensions() {
			self.height = element.outerHeight(true);
			self.top = element.offset().top;
			self.bottom = self.top + self.height;
		}

	}

	function normalizeNav() {
		var headerHeight = $('#header').outerHeight(true);
		$('.app_nav').css('top', headerHeight+'px');
	}

	function updateNav() {
		var y = $(window).scrollTop(),
			jblHeaderHeight = $('#header').outerHeight(true) + $('.app_nav').outerHeight(true),
			compareTop = y + jblHeaderHeight;
		for (var i = sections.length - 1; i >= 0; i--) {
			if ( compareTop >= sections[i].top && compareTop <= sections[i].bottom ) {
				var hash = sections[i].hash;
				if ( $('.app_nav .app_active').attr('href') !== '#' + hash ) {
					$('.app_nav .app_active').removeClass('app_active');
					$('.app_nav a[href="#'+hash+'"]').addClass('app_active');
					// var baseUrl = window.location.href.split('#')[0];
					// window.location.replace(baseUrl + '#' + hash);
					window.location.hash = '#' + hash;
				}
				break;
			}
		}
	}

	function scrollToHash(hash) {
		for (var i = sections.length - 1; i >= 0; i--) {
			if ( hash == sections[i].hash ) {
				var jblHeaderHeight = $('#header').outerHeight(true) + $('.app_nav').outerHeight(true),
					destination = Math.ceil(sections[i].top - jblHeaderHeight);
				$('html, body').scrollTop(destination);
				break;
			}
		}
	}

})(window,jQuery);
